/*
 * Copyright (c) Nexign, JSC, 1992-2022.
 */
/**
 * Personal data delete modal windows defaults.
 *
 * @author Dmitriy Kvon
 * @version 1.17.0
 * @since 1.17.0
 */

import { IPersonalDataDeleteTranslation } from '../../types';

export const initialPersonalDataDeleteTranslation: IPersonalDataDeleteTranslation = {
    status: {
        start: {
            title: '',
            text: '',
        },
        success: {
            orderName: '',
        },
        failure: {
            title: '',
            text: '',
        },
    },
};
